import gql from 'graphql-tag';

export const GET_MEMBER_RANK = gql`
    query ($member_no: ID) {
        getMemberRankByMemberId(
            member_no: $member_no
        )
        {
            member_rank
        }
    },
`;

// メインメニュー取得
export const GET_MENU = gql`
query ($memberNo: ID) {
    GetMenu(
        memberNo: $memberNo
    )
    {
        id
        title
        class
        to
        name
        iconclass
        childhas
        external_link
        children {
            id
            title
            class
            to
            name
            iconclass
            grandChildhas
            external_link
        }
    }
},
`;
